export default __webpack_public_path__ + "static/media/purple.5b735063.png";